<template lang="">
    <div class="pain__scale_content_left">
        <div class="pain__scale_title" v-if="contentData.title">
            {{ contentData.title }}
        </div>
        <div class="pain__block_types">
            <div class="pain__block pain__block_1" n-if="contentData.pain_1">
                <div class="pain__block_text">
                    {{ contentData.pain_1 }}
                </div>
            </div>
            <div class="pain__block pain__block_2" n-if="contentData.pain_2">
                <div class="pain__block_text">
                    {{ contentData.pain_2 }}
                </div>
            </div>
            <div class="pain__block pain__block_3" n-if="contentData.pain_3">
                <div class="pain__block_text">
                    {{ contentData.pain_3 }}
                </div>
            </div>
        </div>
    </div>
    <div class="pain__scale_content_right" v-if="currentPainItem">
        <div class="pain__scale_image-block">
            <div
                class="image"
                v-for="(item, index) in painItems"
                :key="item._uuid"
                v-html="item['image_html']"
                v-show="currentPainValue === index"
            ></div>
            <div class="pain__scale_image-text" v-if="currentPainItem['title']">
                {{currentPainItem['title']}}
            </div>
        </div>
        <div class="pain__scale_range-wrapper">
            <div class="pain__scale_labels">
                <div 
                    v-for="(item, index) in painItems"
                    :key="item._uuid"
                    class="pain__scale_label"
                    :class="[
                    { active: currentPainValue === index },
                        index % 2 === 0 ? 'left' : 'right'
                    ]"
                    :style="{ bottom: getLabelPosition(index) + 'px', backgroundColor: item.color_bg }"
                    @click="changePainValue(index)"
                >
                    {{ item.points_text }}
                </div>
            </div>

            <div class="pain-range-wrap">
                <input 
                    type="range"
                    class="pain-range vertical"
                    min="0"
                    :max="painItems.length - 1"
                    step="1"
                    v-model.number="currentPainValue"
                >
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        contentData: {
            type: Object,
            required: true,
        },
        painItems: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            currentPainValue: 0,
        };
    },
    computed: {
        currentPainItem() {
            return this.painItems[this.currentPainValue];
        },
    },
    methods: {
        // равномерное распределение labels
        getLabelPosition(index) {
            // if (this.painItems.length <= 1) return 0;
            // return (index / (this.painItems.length - 1)) * 100;

            let steps = this.painItems.length - 1;
            let trackHeight = 390; // высота трека
            let thumbOffset = 20;  // половина высоты бегунка

            if (window.innerWidth <= 992) {
                trackHeight = 295;
            }

            if (steps === 0) return thumbOffset;

            if (index === 0) return 0;
            if (index === steps) return trackHeight;

            let usableHeight = trackHeight - thumbOffset * 2;
            return (index / steps) * usableHeight + thumbOffset;
        },
        changePainValue(index) {
            this.currentPainValue = index;            
        }
  }
}
</script>